import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  root: (props) => {
    return {
      '& label.Mui-focused': {
        color: props.inputColor,
        backgroundColor: props.labelBackground,
        padding: () => '0 2px',
      },
      '& label': {
        backgroundColor: props.labelBackground,
        padding: () => '0 2px',
      },
      '& .MuiInput-underline:after': { borderBottomColor: props.inputColor },
      '& .MuiOutlinedInput-root': {
        backgroundColor: props.backgroundColor,
        '&.Mui-focused fieldset': { borderColor: props.inputColor },
      },
    };
  },
});

function StyledTextField(props) {
  const {
    inputColor,
    labelBackground,
    backgroundColor,
    error,
    helperText,
    required,
    ...other
  } = props;

  const classes = useStyles({ inputColor, labelBackground, backgroundColor });

  return (
    <TextField
      classes={{ root: classes.root }}
      error={error}
      helperText={helperText}
      required={required}
      {...other}
    />
  );
}

StyledTextField.propTypes = {
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  inputColor: PropTypes.string,
  label: PropTypes.node,
  labelBackground: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.node,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

StyledTextField.defaultProps = {
  backgroundColor: 'transparent',
  error: false,
  fullWidth: true,
  helperText: undefined,
  id: undefined,
  inputColor: '#60aac6',
  label: undefined,
  labelBackground: '#fff',
  name: undefined,
  placeholder: undefined,
  required: false,
  type: undefined,
  value: undefined,
  onChange: undefined,
  disabled: undefined,
  size: 'small',
  variant: 'outlined',
};

export default StyledTextField;
